import React from 'react';

/**
 * Theme step 2: keeps its subtree on the DARK tokens whatever the page theme is. Used for the footers, which the owner
 * keeps unchanged (GatewayFooter / SystemStatusFooter). `display: contents` → no box of its own, so layout is untouched;
 * the custom properties still inherit through it. In the dark theme it is a no-op (same token values).
 */
export default function DarkIsland({ children }: { children: React.ReactNode }) {
  return <div data-theme="dark" className="contents">{children}</div>;
}
